<template>
  <div class="tactic-fields">
    <!-- The card name and id are edited in the header (TitleBar), not here — mirrors
         how a battleplan's name lives in its title bar rather than its rules form. -->
    <StField class="field--full" label="Text">
      <StTextarea
        :model-value="card.text"
        placeholder="Flavour or rules text…"
        @update:model-value="updateField('text', $event)"
      />
    </StField>

    <!-- Sub-tactic blocks: Affray / Strike / Domination -->
    <div v-for="sub in subTactics" :key="sub.field" class="tactic-fields__sub">
      <span class="tactic-fields__sub-label">{{ sub.label }}</span>
      <StField label="Name">
        <StTextInput
          :model-value="card[sub.field].name"
          :placeholder="`${sub.label} name`"
          @update:model-value="updateSubField(sub.field, 'name', $event)"
        />
      </StField>
      <StField label="Description">
        <StTextarea
          :model-value="card[sub.field].description"
          :placeholder="`${sub.label} description…`"
          @update:model-value="updateSubField(sub.field, 'description', $event)"
        />
      </StField>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type IBattleTactic, type IBattleTacticCard } from '@scrolldex/shared';
import { StField, StTextInput, StTextarea } from './ui/index.js';

const props = defineProps<{
  card: IBattleTacticCard;
}>();

const emit = defineEmits<{
  (e: 'update:card', value: IBattleTacticCard): void;
}>();

const subTactics: { field: 'affray' | 'strike' | 'domination'; label: string }[] = [
  { field: 'affray', label: 'Affray' },
  { field: 'strike', label: 'Strike' },
  { field: 'domination', label: 'Domination' },
];

function updateField(field: keyof IBattleTacticCard, value: unknown) {
  emit('update:card', { ...props.card, [field]: value });
}

function updateSubField(
  sub: 'affray' | 'strike' | 'domination',
  field: keyof IBattleTactic,
  value: unknown,
) {
  emit('update:card', { ...props.card, [sub]: { ...props.card[sub], [field]: value } });
}
</script>

<style scoped>
.tactic-fields {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-2);
}

.tactic-fields :deep(.field--full) {
  width: 100%;
}

.tactic-fields__sub {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-1);
  padding: var(--st-space-2);
  background: var(--st-surface-raised, var(--st-surface));
  border-radius: var(--st-radius-sm);
  border: 1px solid var(--st-border);
}

.tactic-fields__sub-label {
  font-size: var(--st-text-xs);
  font-weight: var(--st-weight-semibold);
  color: var(--st-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
</style>
